// FILE: src/components/CoachInsightCard.js
//
// Compact coach avatar + speech-bubble card at the top of the coaching rail.
// Pose is driven by readiness status and trend:
//   - exam_ready / trending up → cheer or thumbsup
//   - getting_close            → thumbsup
//   - building_foundation      → notepad
//   - not_started              → idle
//
// Speech text is a short coaching headline derived from the same signals.

import React from 'react';
import styles from './CoachInsightCard.module.css';
import CoachAvatar from './CoachAvatar';

export default function CoachInsightCard({ examLabel, readiness, trend }) {
  const status = readiness?.status || 'not_started';
  const pose = pickPose(status, trend);
  const speech = pickSpeech(status, trend);

  return (
    <div className={styles.card}>
      <div className={styles.head}>PM Pixel Coaching</div>
      <div className={styles.body}>
        <CoachAvatar pose={pose} heightPx={156} decorative />
        <div className={styles.speech}>{speech}</div>
      </div>
    </div>
  );
}

function pickPose(status, trend) {
  if (status === 'exam_ready')                    return 'cheer';
  if (trend?.direction === 'up')                  return 'thumbsup';
  if (status === 'getting_close')                 return 'thumbsup';
  if (status === 'building_foundation')           return 'notepad';
  return 'idle';
}

function pickSpeech(status, trend) {
  if (status === 'exam_ready')                    return "You're exam-ready — book the date!";
  if (status === 'not_started')                   return "Let's set your baseline and map the path.";
  if (trend?.direction === 'up')                  return "You've got this. Stay focused and finish strong!";
  if (trend?.direction === 'down')                return 'Small dip — one focused session turns it around.';
  if (status === 'getting_close')                 return "You're close. Keep the rhythm going.";
  if (status === 'building_foundation')           return "Solid foundation work — keep building.";
  return "One step at a time.";
}
